import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { Input } from '@/components/ui/input'
import { Textarea } from '@/components/ui/textarea'
import { AuthorImageUploader } from './AuthorImageUploader'
import { RoleSelect } from './RoleSelect'

export function AuthorForm({ formId, draft, setDraft, uploading, onUpload, onSubmit }) {
  function updateField(field, value) {
    setDraft((current) => ({ ...current, [field]: value }))
  }

  async function handleImageUpload(file) {
    const url = await onUpload(file)
    if (url) updateField('image', url)
  }

  return (
    <form id={formId} className="grid gap-6 lg:grid-cols-[1fr_320px]" onSubmit={(event) => { event.preventDefault(); onSubmit() }}>
      <div className="space-y-4">
        <Card>
          <CardContent className="space-y-4 pt-6">
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-1.5">
                <label className="text-sm font-medium">Full name <span className="text-destructive">*</span></label>
                <Input value={draft.full_name} onChange={(event) => updateField('full_name', event.target.value)} required />
              </div>
              <div className="space-y-1.5">
                <label className="text-sm font-medium">Role</label>
                <RoleSelect
                  value={draft.role_id ?? null}
                  onChange={(roleId) => updateField('role_id', roleId)}
                />
              </div>
            </div>
            <div className="grid grid-cols-2 gap-4">
              <div className="space-y-1.5">
                <label className="text-sm font-medium">Email</label>
                <Input type="email" value={draft.email} onChange={(event) => updateField('email', event.target.value)} />
              </div>
              <div className="space-y-1.5">
                <label className="text-sm font-medium">Contact number</label>
                <Input value={draft.contact_number} onChange={(event) => updateField('contact_number', event.target.value)} />
              </div>
            </div>
            <div className="space-y-1.5">
              <label className="text-sm font-medium">Description</label>
              <Textarea rows={5} value={draft.description} onChange={(event) => updateField('description', event.target.value)} />
            </div>
          </CardContent>
        </Card>
      </div>

      <div className="space-y-4">
        <Card>
          <CardContent className="space-y-4 pt-6">
            <div className="space-y-1.5">
              <label className="text-sm font-medium">Profile image</label>
              <AuthorImageUploader
                image={draft.image}
                name={draft.full_name}
                uploading={uploading}
                onUpload={handleImageUpload}
                onImageChange={(value) => updateField('image', value)}
              />
            </div>
          </CardContent>
        </Card>
      </div>
    </form>
  )
}
